import { Injectable, Provider } from '@angular/core';
import { EOrderTyp } from '../../../enum/order-typ.enum';
import { EOfferTyp } from '../../../enum/offer-typ.enum';
import { ITooltipService, ITooltipServiceToken } from './tooltip-service.interface';

@Injectable({
  providedIn: 'root'
})
export class TooltipService implements ITooltipService {

  public tooltipGetGeneric(headerMessage?: string, bodyMessage?: string): string {
    let resultString = '';

    if (headerMessage != undefined) {
      resultString = resultString + "<h5 class='tooltip-header fs-6'>";
      resultString = resultString + '<span>';
      resultString = resultString + headerMessage;
      resultString = resultString + '</span>';
      resultString = resultString + '</h5>';
    }

    if (headerMessage != undefined && bodyMessage != undefined) {
      resultString = resultString + "<div class='tooltip-hborderspacer' ></div>";
    }

    if (bodyMessage != undefined) {
      resultString = resultString + "<div class='tooltip-body' >";
      resultString = resultString + bodyMessage;
      resultString = resultString + '</div>';
    }

    return resultString;
  }

  public priceMissingInfoIconToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';
    resultString = resultString + '<span>';
    let headerMessage = $localize`:@@ToolTipServicePriceMissingInfoIconToolTipHeader:Price information`;
    resultString = resultString + headerMessage;
    resultString = resultString + '</span>';
    resultString = resultString + '</h5>';

    resultString = resultString + '<div class="tooltip-hborderspacer" ></div>';

    resultString = resultString + '<div class="tooltip-body" >';
    resultString = resultString + '<span>';
    let bodyMessage = $localize`:@@ToolTipServicePriceMissingInfoIconToolTipBody:Prices are visible after login`;
    resultString = resultString + bodyMessage;
    resultString = resultString + '</span>';
    resultString = resultString + '</div>';

    return resultString;
  }

  public categoryTreeToggleButtonToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceCategoryTreeToggleButtonToolTipHeader:Display or hide the category tree`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public addToCartIconToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceAddToCartIconToolTipHeader:Add to cart`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public deliveryInformationIconToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceDeliveryInformationIconToolTipHeader:Toggle delivery information`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public removeFromComparisonIconToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceDeleteFromComparisonIconToolTipHeader:Remove from comparison`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public deleteUserIconToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceDeleteUserIconToolTipHeader:Remove this user`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }


  public deleteFromCartManagementIconToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceDeleteFromCartManagementIconToolTipHeader:Remove this shopping cart`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public deleteFromCartIconToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceDeleteFromShoppingCartIconToolTipHeader:Remove this product`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public priceAfterRequestIconToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServicepriceAfterRequestIconToolTipHeader:Price only available on Request`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public deleteFromListIconToolTipGet(): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceDeleteFromListIconToolTipHeader:Remove from list`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public productToolTipGet(productNumber: string, productHtmlToolTipText: string): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceProductToolTipHeader:Details from article:`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '<span> </span>';

    resultString = resultString + '<span>';
    resultString = resultString + productNumber;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    resultString = resultString + '<div class="tooltip-hborderspacer" ></div>';

    resultString = resultString + '<div class="tooltip-body tooltip-body-product" >';
    resultString = resultString + '<div>';
    resultString = resultString + productHtmlToolTipText;
    resultString = resultString + '</div>';
    resultString = resultString + '</div>';

    return resultString;
  }

  public compareToolTipGet(): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceCompareToolTipHeader:Add or remove ro comparison`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;

  }

  public techGroupToolTipGet(techGroupNumber: string): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceTechGroupToolTipHeader:Please click here for further models`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public favoriteToolTipGet(): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceFavoriteToolTipHeader:Add to or remove from favorites`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public favoriteTopNavToolTipGet(): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceFavoriteTopNavToolTipHeader:Favorite articles`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public comparisonToolTipGet(): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceCompareTopNavToolTipHeader:Compare articles`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public historyOrderToolTipGet(): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceOrderHistoryToolTipHeader:Order history`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public historyOfferToolTipGet(): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceOfferHistoryToolTipHeader:Offer history`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public recentlySeenToolTipGet(): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';
    let message = $localize`:@@ToolTipServiceRecentlySeenToolTipHeader:Recently seen articles`;
    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public availabilityToolTipGet(): string {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';
    let title = $localize`:@@ToolTipServiceAvailabilityToolTipHeader:Availability Info`;
    resultString = resultString + title;
    resultString = resultString + '</h5>';

    resultString = resultString + '<div class="tooltip-hborderspacer" ></div>';

    resultString = resultString + '<div class="tooltip-body" >';

    resultString = resultString + '<div class="container p-0" >';

    resultString = resultString + '<div class="row flex-nowrap">';
    resultString = resultString + '<span class="col-auto">';
    let available = $localize`:@@ToolTipServiceAvailabilityToolTipAvailable:Available`;
    resultString = resultString + '<i class="bi bi-circle-fill bi-circle-fill-green"></i>';
    resultString = resultString + '<i class="bi bi-circle-fill bi-circle-fill-green"></i>';
    resultString = resultString + '<i class="bi bi-circle-fill bi-circle-fill-green"></i>';
    resultString = resultString + '</span>';
    resultString = resultString + '<div class="col-auto text-nowrap fs-6">';
    resultString = resultString + available;
    resultString = resultString + '</div>';
    resultString = resultString + '</div>';

    resultString = resultString + '<div class="row flex-nowrap">';
    resultString = resultString + '<span class="col-auto">';
    let limitedAvaible = $localize`:@@ToolTipServiceAvailabilityToolTipLimited:Limited available`;
    resultString = resultString + '<i class="bi bi-circle-fill bi-circle-fill-yellow"></i>';
    resultString = resultString + '<i class="bi bi-circle-fill bi-circle-fill-yellow"></i>';
    resultString = resultString + '<i class="bi bi-circle-fill bi-circle-fill-grey"></i>';
    resultString = resultString + '</span>';
    resultString = resultString + '<div class="col-auto text-nowrap fs-6">';
    resultString = resultString + limitedAvaible;
    resultString = resultString + '</div>';
    resultString = resultString + '</div>';

    resultString = resultString + '<div class="row flex-nowrap">';
    resultString = resultString + '<span class="col-auto">';
    let outOfStock = $localize`:@@ToolTipServiceAvailabilityToolTipOutOfStock:Currently out of stock`;
    resultString = resultString + '<i class="bi bi-circle-fill bi-circle-fill-red"></i>';
    resultString = resultString + '<i class="bi bi-circle-fill bi-circle-fill-grey"></i>';
    resultString = resultString + '<i class="bi bi-circle-fill bi-circle-fill-grey"></i>';
    resultString = resultString + '</span>';
    resultString = resultString + '<div class="col-auto text-nowrap fs-6">';
    resultString = resultString + outOfStock;
    resultString = resultString + '</div>';
    resultString = resultString + '</div>';

    resultString = resultString + '<div class="row flex-nowrap">';
    resultString = resultString + '<span class="col-auto">';
    let ordeRelatedProcurement = $localize`:@@ToolTipServiceAvailabilityToolTipProcurement:Order-related procurement`;
    resultString = resultString + '<i class="bi bi-truck"></i>';
    resultString = resultString + '</span>';
    resultString = resultString + '<div class="col-auto text-nowrap fs-6">';
    resultString = resultString + ordeRelatedProcurement;
    resultString = resultString + '</div>';
    resultString = resultString + '</div>';

    resultString = resultString + '<div>';

    resultString = resultString + '<div>';

    return resultString;
  }

  public orderTypeIconToolTipGet(eOrderTyp: EOrderTyp): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';

    let message: string;
    switch (eOrderTyp) {
      case EOrderTyp.WebshopOrderNumber:
        message = $localize`:@@ToolTipServiceOrderTypeWebshopIconToolTipHeader:The Order was placed via the webshop`;
        break;
      case EOrderTyp.IntegraOrderNumber:
        message = $localize`:@@ToolTipServiceOrderTypeIntegraIconToolTipHeader:The Order was placed via the sales department`;
        break;
      default:
        message = '';
        break;
    }

    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }

  public offerTypeIconToolTipGet(eOfferTyp: EOfferTyp): string | undefined {
    let resultString = '';

    resultString = resultString + '<h5 class="tooltip-header fs-6">';

    resultString = resultString + '<span>';

    let message: string;
    switch (eOfferTyp) {
      case EOfferTyp.WebshopOfferNumber:
        message = $localize`:@@ToolTipServiceOfferTypeWebshopIconToolTipHeader:The Offer was placed via the webshop`;
        break;
      case EOfferTyp.IntegraOfferNumber:
        message = $localize`:@@ToolTipServiceOfferTypeIntegraIconToolTipHeader:The Offer was placed via the sales department`;
        break;
      default:
        message = '';
        break;
    }

    resultString = resultString + message;
    resultString = resultString + '</span>';

    resultString = resultString + '</h5>';

    return resultString;
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const TooltipServiceProvider: Provider[] = [
  { provide: ITooltipServiceToken, useExisting: TooltipService }
];
